export const sidebarMenuItems = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'tickets', label: 'Atendimentos' },
  { key: 'quickMessages', label: 'Respostas rápidas' },
  { key: 'schedules', label: 'Agendamentos' },
  { key: 'tags', label: 'Tags' },
  { key: 'tasks', label: 'Tarefas' },
  { key: 'reminders', label: 'Lembretes' },
  //{ key: 'notificationSounds', label: 'Sons de notificação' },
  { key: 'contacts', label: 'Contatos' },
  { key: 'clients', label: 'Clientes' },
  { key: 'contactFiles', label: 'Arquivos de contatos' },
  { key: 'campaigns', label: 'Campanhas' },
  { key: 'contactLists', label: 'Lista de contatos' },
  { key: 'financeiro', label: 'Financeiro' },
  { key: 'announcements', label: 'Anúncios' },
  { key: 'users', label: 'Usuários' },
  { key: 'reports', label: 'Relatórios' },
  { key: 'managerPanel', label: 'Painel Gestor' },
  { key: 'connections', label: 'Conexões' },
  { key: 'departments', label: 'Departamentos' },
  // { key: 'settings', label: 'Configurações' },
  { key: 'wizard', label: 'Wizard' }
]

// Mantém o comportamento anterior até que a configuração seja personalizada.
export const defaultExperimentalMenuItemKeys = [
  'tasks',
  'reminders',
  'notificationSounds',
  'clients',
  'contactFiles',
  'financeiro',
  'announcements',
  'reports',
  'managerPanel'
]
